import { render, staticRenderFns } from "./BatchDetails.vue?vue&type=template&id=4e53c24e&"
import script from "./BatchDetails.vue?vue&type=script&lang=js&"
export * from "./BatchDetails.vue?vue&type=script&lang=js&"
import style0 from "./BatchDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports